/**
 * 日本語 — Japanese (polite business register).
 * Any key missing here falls back to English (locales/en.js).
 */
export default {
    language: {
        label:  '言語',
        switch: '言語を変更',
        names:  { 'en': '英語', 'zh-TW': '繁体字中国語', 'zh-CN': '簡体字中国語', 'ja': '日本語' },
    },

    suggest: {
        title:   'このサイトは日本語でご利用いただけます',
        body:    '日本語に切り替えますか？言語は後からいつでも変更できます。',
        accept:  '日本語に切り替える',
        decline: '英語のまま続ける',
    },

    common: {
        loading:        '読み込み中...',
        error:          'エラー',
        no_data:        'データがありません。',
        day_n:          '{n}日目',
        try_again:      '再試行',
        close:          '閉じる',
        skip:           'スキップ',
        next:           '次へ >',
        end:            '終了',
        download:       'ダウンロード',
        submit:         '送信',
        add:            '追加',
        download_error: 'ファイルの処理中に問題が発生しました。もう一度お試しいただくか、サポートまでお問い合わせください。',
    },

    page: {
        home:      'ホーム',
        login:     'ログイン',
        chat:      'チャット',
        quotation: '見積書',
        invoices:  '書類',
        contact:   'お問い合わせ',
        help:      'ヘルプ',
        faq:       'よくある質問',
        access:    'アクセス管理',
        notfound:  '404 ページ',
    },

    nav: {
        groups:    '団体',
        chat:      'チャット',
        documents: '書類',
        support:   'サポート',
        help:      'ヘルプ',
        faq:       'よくある質問',
    },

    breadcrumb: {
        quotations: '見積書一覧',
        fit:        'FIT',
        help:       'ヘルプ',
        faq:        'よくある質問',
    },

    header: {
        available:     'オンライン',
        manage_access: 'アクセス管理',
        logout:        'ログアウト',
    },

    notif: {
        count: '{n} 件の新しい通知',
        empty: '通知はありません',
    },

    login: {
        title:        'ログイン',
        username:     'ユーザー名',
        password:     'パスワード',
        button:       'ログイン',
        loading:      '読み込み中...',
        err_username: 'ユーザー名を入力してください',
        err_password: 'パスワードを入力してください',
        err_auth:     '認証に失敗しました。ユーザー名とパスワードをご確認ください。',
        by:           'FiveDragons Agency 提供',
    },

    home: {
        loading: '読み込み中...',
        error:   'エラー！',
    },

    table: {
        invoice:  '請求書番号',
        id:       'ID',
        your_ref: 'お客様参照番号',
        date:     '日付',
        contact:  '担当者',
        status:   'ステータス',
        action:   '操作',
        invalid:  '無効なデータを受信しました。',
    },

    status: {
        archived: 'アーカイブ済み',
        go_ahead: '確定',
        ongoing:  '進行中',
    },

    quotation: {
        title:         '見積書 {ref}',
        loading:       '見積書を読み込んでいます...',
        error:         'データの取得中にエラーが発生しました。',
        last_update:   '最新の更新',
        loading_short: '（読み込み中...）',
        show_chat:     'チャットを表示',
        hide_chat:     'チャットを隠す',
        operating_on:  '現在の対象',
        ref:           '参照番号',
        your_ref:      'お客様参照番号',
        tabs: {
            map:         '地図',
            itinerary:   '旅程',
            hotels:      'ホテル',
            restaurants: 'レストラン',
            monuments:   '観光スポット',
            rates:       '料金',
            files:       'ファイル',
        },
        tour: {
            step1: '詳細情報はこれらのタブにあります...',
            step2: 'ここで担当者とリアルタイムでチャットできます。',
            step3: 'チャットを非表示にして、表示スペースを広げることもできます。',
        },
    },

    badge: {
        waiting_list:    'キャンセル待ち',
        no_availability: '空きなし',
        confirmed:       '確認済み',
        canceled:        'キャンセル',
        on_request:      'リクエスト中',
    },

    hotels: {
        day:    '日次',
        hotel:  'ホテル',
        city:   '都市',
        status: 'ステータス',
    },

    deadlines: {
        deadline:         'キャンセル期限',
        tab:              'キャンセル期限',
        title:            'キャンセル期限（この日まで無料キャンセル可）',
        intro:            'サプライヤーはキャンセル期限まで予約を仮押さえしています。期限を過ぎると予約は確定となり、キャンセルできず、お支払いが必要になります。',
        summary_critical: '3週間以内のキャンセル期限が {n} 件',
        summary_warning:  '2か月以内が {n} 件',
        none_soon:        '今後2か月以内にキャンセル期限はありません。',
        passed:           '期限切れ',
        none:             'キャンセル期限なし',
        supplier:         'サプライヤー',
        type:             '種類',
        city:             '都市',
        day:              '日次',
        date:             'キャンセル期限',
        time_left:        '残り時間',
        since:            '仮押さえ開始日',
        type_hotel:       'ホテル',
        type_restaurant:  'レストラン',
        tooltip:          '{date} まで無料キャンセル可',
        tooltip_since:    '（{date} から仮押さえ）',
        legend_critical:  '3週間以内',
        legend_warning:   '2か月以内',
        legend_moderate:  '6か月未満',
        legend_safe:      '6か月以上',
        legend_passed:    '期限切れ',
    },

    map: {
        loading: '地図を読み込んでいます。しばらくお待ちください...',
        error:   'プレビューを読み込めませんでした。',
        alt:     '地図',
        title:   '地図プレビュー',
    },

    monuments: {
        name:     '名称',
        location: '場所',
        docs:     '資料',
    },

    rates: {
        unavailable:  'この見積書の料金はまだご利用いただけません。',
        retry_prefix: 'しばらくしてから再度お試しいただくか、',
        contact_us:   'お問い合わせ',
        retry_suffix: 'ください。',
        pax:          '人数',
    },

    restaurants: {
        day:     '日次',
        name:    '名称',
        status:  'ステータス',
        menu_of: '{name} のメニュー - {day}日目',
    },

    chat: {
        loading:           '読み込み中...',
        talking_in_prefix: '',
        talking_in_suffix: ' で会話中です',
        says_prefix:       '',
        says_suffix:       ' さん：',
        uploading:         'アップロード中...',
        bad_response:      'サーバーから予期しない応答がありました。',
        placeholder:       'ここに入力...',
        try_again:         '再試行',
        active:            'オンライン',
        connecting:        '接続中...',
        done:              '完了',
        error_prefix:      'エラー：',
        home:              'ホーム',
        quotation_prefix:  '見積書/',
    },

    files: {
        error:         'エラー。',
        loading:       '読み込み中...',
        empty:         'ファイルが見つかりません。',
        folder:        'フォルダー',
        files:         'ファイル',
        folders:       'フォルダー',
        last_accessed: '最終アクセス：',
        count:         '{n} 件のファイル',
        group:         '団体 {n}',
        details:       '詳細',
        activity:      'アクティビティ',
        download:      'ダウンロード',
        info:          '情報',
        type:          '種類',
        size:          'サイズ',
        location:      '場所',
        created:       '作成日',
        creation:      '作成',
    },

    access: {
        agents:    '担当者',
        none:      '現在、担当者は登録されていません。以下のフォームから追加してください。',
        add_title: '担当者を追加',
        fullname:  '氏名',
        username:  'ユーザー名',
        password:  'パスワード',
        add:       '追加',
    },

    help: {
        title:               'ヘルプ',
        subject:             '件名：',
        subject_placeholder: '件名を入力してください',
        message:             'メッセージ',
        message_placeholder: 'メッセージを入力してください',
        submit:              '送信',
    },

    contact: {
        redirecting: 'リダイレクトしています。しばらくお待ちください...',
    },

    notfound: {
        title: '404 - ページが見つかりません',
        body:  '申し訳ありませんが、お探しのページは見つかりませんでした。',
    },
};
